/*
 * @Author: liuyongjun
 * @Date: 2023-02-07 09:47:12
 * @LastEditors: bianbinbin
 * @LastEditTime: 2025-12-18 16:27:55
 * @PageTitle: 页面...
 * @Description: 描述...
 * @FilePath: /ejx-web/src/plugins/vant.js
 */
import Vue from 'vue'
// import enUS from 'vant/es/locale/lang/en-US'
import {
  Button,
  Calendar,
  Cell,
  CellGroup,
  Checkbox,
  CheckboxGroup,
  Col,
  DatetimePicker,
  Dialog,
  Field,
  Form,
  Icon,
  Loading,
  Row,
  Picker,
  Popup,
  Tag,
  Toast,
  NavBar,
  PullRefresh,
  List,
  Search,
  ActionSheet,
  Uploader,
  Tab,
  Tabs,
  Radio,
  RadioGroup,
  Divider,
  IndexBar,
  IndexAnchor,
  Switch,
  Empty,
  NoticeBar,
  CountDown,
  SwipeCell,
  Circle,
  Step,
  Steps,
  Stepper,
  NumberKeyboard,
  Progress,
  Swipe,
  SwipeItem,
  DropdownMenu,
  DropdownItem,
  Lazyload,
  Collapse,
  CollapseItem,
  Panel,
  Popover,
  Tabbar,
  TabbarItem,
  Overlay,
  Grid,
  GridItem,
  Image as VanImage,
  Skeleton
} from 'vant'

Vue.use(Button)
Vue.use(Calendar)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Col)
Vue.use(DatetimePicker)
Vue.use(Dialog)
Vue.use(Field)
Vue.use(Form)
Vue.use(Icon)
Vue.use(Loading)
Vue.use(Row)
Vue.use(Picker)
Vue.use(Popup)
Vue.use(Tag)
Vue.use(Toast)
Vue.use(NavBar)
Vue.use(PullRefresh)
Vue.use(List)
Vue.use(Search)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(ActionSheet)
Vue.use(Uploader)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Divider)
Vue.use(IndexBar)
Vue.use(IndexAnchor)
Vue.use(Empty)
Vue.use(NoticeBar)
Vue.use(Switch)
Vue.use(CountDown)
Vue.use(SwipeCell)
Vue.use(Circle)
Vue.use(Step)
Vue.use(Steps)
Vue.use(Stepper)
Vue.use(NumberKeyboard)
Vue.use(Progress)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Lazyload)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Panel)
Vue.use(Popover)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Overlay)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(VanImage)
Vue.use(Skeleton)
// Locale.use('en-US', enUS)
